module.exports = __webpack_public_path__ + "img/twitter.b28ac978.png";